export const ADDRESS_INFORMATION_LOADING_STATES = {
    ZIP_VALIDATION_LOADING: "ZIP_VALIDATION_LOADING",
    ZIP_VALIDATION_READY: "ZIP_VALIDATION_READY",
    CALCULATE_SALES_TAX_LOADING: "CALCULATE_SALES_TAX_LOADING",
    CALCULATE_SALES_TAX_READY: "CALCULATE_SALES_TAX_READY",
}

export const ADDRESS_INFORMATION_MESSAGE_MAP = {
    [ADDRESS_INFORMATION_LOADING_STATES.ZIP_VALIDATION_LOADING]: "validating zipcode",
    [ADDRESS_INFORMATION_LOADING_STATES.CALCULATE_SALES_TAX_LOADING]: "calculating sales tax",
}